<script setup>
import {computed} from 'vue'
import {useComponentsStore} from '@/stores/components'
import {useModalsStore} from '@/stores/modals'
import {useFormStore} from '@/stores/form'
import FormSidebarBtn from "@/common/form/FormSidebarBtn.vue"

const props = defineProps({
    formId: String,
})

// Pinia Stores
const componentsStore = useComponentsStore()
const modalsStore = useModalsStore()
const formStore = computed(() => props.formId ? useFormStore(props.formId) : null)

// --- Computed Properties ---
const tableName = computed(() => {
    return formStore.value?.tableName
})

const id = computed(() => {
    return formStore.value?.id
})

const tagsEnabled = computed(() => {
    const componentObj = componentsStore.items.find(obj => obj.tableName === tableName.value)
    return componentObj ? componentObj.showTags : false
})

const show = computed(() => {
    return tagsEnabled.value && id.value
})

// --- Methods ---
const modal = () => {
    modalsStore.show({
        componentName: 'TagsModal',
        obj: {
            tableName: tableName.value,
            id: id.value,
        }
    })
}
</script>

<template>
    <FormSidebarBtn v-if="show" @click.prevent="modal">
        <i class="me-2 bi-tags-fill"/>
        Open tags
    </FormSidebarBtn>
</template>